import { useMutation, useQueryClient } from '@tanstack/react-query';
import createSRTTrunk from 'API/SRT/createSRTTrunk';

/**
 * Creates an SRT trunk.
 *
 * @returns TanStack mutation taking the trunk payload.
 */
const useCreateSRTTrunk = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const res = await createSRTTrunk(payload);
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['getSRTTrunks'] });
        },
    });
};

export default useCreateSRTTrunk;
